export default __webpack_public_path__ + "static/reviews-video-delaine-e40934ba785f71b679881a8e8dfa0514.png";